"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AnalyticsQueue = void 0;
var _uiFrameworksComponents = require("@att-bit/ui-frameworks.components.analytics-event");
var _docComplete = require("./docComplete");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class AnalyticsQueue {
  static getInstance() {
    if (!AnalyticsQueue.instance) AnalyticsQueue.instance = new AnalyticsQueue();
    return AnalyticsQueue.instance;
  }
  constructor() {
    _defineProperty(this, "impressionArray", void 0);
    _defineProperty(this, "pageLoadComplete", void 0);
    this.impressionArray = [];
    this.pageLoadComplete = false;
  }
  setImpression(data) {
    if (this.pageLoadComplete) {
      (0, _uiFrameworksComponents.AnalyticsEvent)(data);
      if (window) window["Invoca"] && window["Invoca"].PNAPI.run();
    } else {
      this.impressionArray.push(data);
    }
  }
  sendPageLoad(pageLoadData) {
    this.sendEvent();
  }
  sendEvent() {
    (0, _docComplete.docComplete)(() => {
      const tempArray = [...this.impressionArray];
      this.impressionArray = [];
      this.pageLoadComplete = true;
      tempArray.forEach(item => {
        (0, _uiFrameworksComponents.AnalyticsEvent)(item);
      });
    });
  }
}
exports.AnalyticsQueue = AnalyticsQueue;
_defineProperty(AnalyticsQueue, "instance", null);
var _default = AnalyticsQueue.getInstance();
exports.default = _default;

//# sourceMappingURL=queue-events.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@att-bit/ui-frameworks.components.analytics-event/dist/queue-events.js
// module id = 1421
// module chunks = 8